import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Container from '../../../common/base/Container';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import { TeamPermission } from '../../../contexts/TeamPermissionContext';
import { DashboardContext } from '../DashboardContext';
import AccountProfile from './Account/AccountProfile';
import AccountKeysAndSessions from './Account/KeysAndSessions';
import TeamApiKeys from './Team/TeamApiKeys';
import OrganizationBilling from './Organization/OrganizationBilling';
import TeamMembers from './Organization/OrganizationMembers';
import TeamQuotas from './Team/TeamQuotas';
import TeamSettings from './Team/TeamSettings';
import TeamAccessControl from './Team/TeamAccessControl';
import TeamIntegrations from './Team/TeamIntegrations';
import OrganizationSettings from './Organization/OrganizationSettings';
import { Redirect } from 'react-router';
import ViewRoute from '../../../common/ViewRoute';
import SettingsNav, { StyledSettingsNavHeader } from '../Nav/SettingsNav';
import { StyledViewContent, StyledViewLayout } from '../../../layouts/ViewLayout';
import OrganizationApiKeys from './Organization/OrganizationApiKeys';
import OrganizationPlans from './Organization/OrganizationPlans';
const StyledSettingsView = styled.div`
  display: grid;
  grid-template-columns: 224px 1fr;
  position: relative;

  > div:first-child {
    height: fit-content;
    position: sticky;
  }
`;
const Settings: React.FC = () => {
  const $ = _c(50);
  const {
    is_degraded_banner_active
  } = useContext(DashboardContext);
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let T5;
  let sections;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== is_degraded_banner_active) {
    sections = {
      project: [{
        key: "settings",
        path: "/settings/project/general",
        label: "Project Settings",
        icon: "settings",
        Component: TeamSettings
      }, {
        key: "secrets",
        path: "/settings/project/secrets",
        label: "Project Secrets",
        icon: "key",
        Component: TeamApiKeys
      }, {
        key: "access",
        path: "/settings/project/access",
        label: "Project Access Control",
        icon: "group",
        Component: TeamAccessControl
      }, {
        key: "integrations",
        path: "/settings/project/integrations",
        label: "Project Integrations",
        icon: "tune",
        Component: TeamIntegrations
      }, {
        key: "quotas",
        path: "/settings/project/quotas",
        label: "Project Quotas",
        icon: "rate_limit",
        Component: TeamQuotas
      }],
      organization: [{
        key: "general",
        path: "/settings/organization/general",
        label: "Organization",
        icon: "settings",
        Component: OrganizationSettings
      }, {
        key: "members",
        path: "/settings/organization/members",
        label: "Organization Members",
        icon: "team",
        Component: TeamMembers
      }, {
        key: "api_keys",
        path: "/settings/organization/api-keys",
        label: "Organization API Keys",
        icon: "key",
        Component: OrganizationApiKeys
      }, {
        key: "billing",
        path: "/settings/organization/billing",
        label: "Organization Billing",
        icon: "billing",
        Component: OrganizationBilling
      }, {
        key: "plans",
        path: "/settings/organization/plans",
        label: "Hookdeck Plans",
        icon: "billing",
        Component: OrganizationPlans
      }, {
        key: "outpost_plans",
        path: "/settings/organization/outpost/plans",
        label: "Hookdeck Outpost Plans",
        icon: "billing",
        Component: OrganizationPlans
      }],
      account: [{
        key: "keys_and_sessions",
        path: "/settings/account/keys-and-sessions",
        label: "Keys & Sessions",
        icon: "key",
        Component: AccountKeysAndSessions
      }]
    };
    const is_outpost_plans_path = location.pathname.includes("/settings/organization/outpost/plans");
    const sections_list = [...sections.project, ...sections.organization, ...sections.account];
    const current_section = is_outpost_plans_path ? sections.organization.find(_temp) : sections_list.find(_temp2);
    T5 = StyledViewLayout;
    T4 = StyledViewContent;
    let t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        align: "center",
        justify: "space-between"
      };
      t7 = {
        x: 6,
        y: 4
      };
      $[14] = t6;
      $[15] = t7;
    } else {
      t6 = $[14];
      t7 = $[15];
    }
    t5 = <StyledSettingsNavHeader flex={t6} p={t7} is_degraded_banner_active={is_degraded_banner_active}><Text semi={true}>{current_section?.label || "Profile"}</Text></StyledSettingsNavHeader>;
    T3 = StyledSettingsView;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <SettingsNav />;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    T2 = Div;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        direction: "column"
      };
      t3 = {
        t: 6,
        b: 8
      };
      $[17] = t2;
      $[18] = t3;
    } else {
      t2 = $[17];
      t3 = $[18];
    }
    T1 = Div;
    T0 = Switch;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ViewRoute title="Profile" path="/settings/account/profile" render={_temp3} />;
      $[19] = t0;
    } else {
      t0 = $[19];
    }
    t1 = sections.account.map(_temp4);
    $[0] = is_degraded_banner_active;
    $[1] = T0;
    $[2] = T1;
    $[3] = T2;
    $[4] = T3;
    $[5] = T4;
    $[6] = T5;
    $[7] = sections;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    T0 = $[1];
    T1 = $[2];
    T2 = $[3];
    T3 = $[4];
    T4 = $[5];
    T5 = $[6];
    sections = $[7];
    t0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[20] !== sections.project) {
    t6 = <Route path="/settings/project" render={() => <TeamPermission role="member"><Div><Switch>{sections.project.map(_temp5)}<Redirect to="/settings/project/general" /></Switch></Div></TeamPermission>} />;
    $[20] = sections.project;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== sections.organization) {
    t7 = <Route path="/settings/organization" render={() => <TeamPermission role="member"><Switch>{sections.organization.map(_temp6)}<Redirect to="/settings/organization/general" /></Switch></TeamPermission>} />;
    $[22] = sections.organization;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Redirect to="/settings/project/general" />;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== T0 || $[26] !== t0 || $[27] !== t1 || $[28] !== t6 || $[29] !== t7) {
    t9 = <T0>{t0}{t1}{t6}{t7}{t8}</T0>;
    $[25] = T0;
    $[26] = t0;
    $[27] = t1;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== T1 || $[32] !== t9) {
    t10 = <T1>{t9}</T1>;
    $[31] = T1;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== T2 || $[35] !== t10 || $[36] !== t2 || $[37] !== t3) {
    t11 = <T2 flex={t2} p={t3}>{t10}</T2>;
    $[34] = T2;
    $[35] = t10;
    $[36] = t2;
    $[37] = t3;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== T3 || $[40] !== t11 || $[41] !== t4) {
    t12 = <T3>{t4}{t11}</T3>;
    $[39] = T3;
    $[40] = t11;
    $[41] = t4;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== T4 || $[44] !== t12 || $[45] !== t5) {
    t13 = <T4>{t5}{t12}</T4>;
    $[43] = T4;
    $[44] = t12;
    $[45] = t5;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  let t14;
  if ($[47] !== T5 || $[48] !== t13) {
    t14 = <T5>{t13}</T5>;
    $[47] = T5;
    $[48] = t13;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  return t14;
};
export default Settings;
function _temp(section) {
  return section.key === "plans";
}
function _temp2(section_0) {
  return location.pathname.includes(section_0.path);
}
function _temp3() {
  return <Div><AccountProfile /></Div>;
}
function _temp4(section_1) {
  return <ViewRoute title={section_1.label} path={section_1.path} key={section_1.key}><Container large={true} left={true}><section_1.Component /></Container></ViewRoute>;
}
function _temp5(section_2) {
  return <ViewRoute title={section_2.label} path={section_2.path} key={section_2.key}><section_2.Component /></ViewRoute>;
}
function _temp6(section_3) {
  return <ViewRoute title={section_3.label} path={section_3.path} key={section_3.key}><section_3.Component /></ViewRoute>;
}